<div class="flex space-between">
  <div class="heading-1 break-word">{{ 'general.api_menu_delivery_types' | translate }}</div>
  <div>
    <button mat-stroked-button color="primary" class="compact-medium" (click)="createDeliveryType()">
      {{ 'general.api_delivery_types_create_new' | translate }}
    </button>
  </div>
</div>
<app-loader [loading]="isLoading" [overlay]="true"></app-loader>

<mat-tab-group mat-align-tabs="left" class="tabs no-body max-width bottom-spacer" [(selectedIndex)]="activeTab" (selectedIndexChange)="changeTab()">
  <mat-tab [label]="'general.api_delivery_types_tab_active' | translate"></mat-tab>
  <mat-tab [label]="'general.api_delivery_types_tab_inactive' | translate"></mat-tab>
</mat-tab-group>
<ng-container *ngIf="!isLoading">
  <app-info-message *ngIf="!sortedDeliveryTypes?.length"
                    [message]="'general.api_delivery_types_no_results'" [large]="true"></app-info-message>
  <mat-card appearance="outlined" *ngIf="sortedDeliveryTypes?.length">
    <!-- DESKTOP -->
    <table class="report-table manual-alternating-color" *ngIf="!utilService.isMobile">
      <thead>
      <tr class="break-word">
        <th class="min-width">
          <button mat-button class="icon-button input-button small" (click)="areAllExpanded ? collapseAll() : expandAll()" [disabled]="activeTab === 0 ? !activeExpandableCount : !pastExpandableCount">
            <mat-icon class="svg-icon" [svgIcon]="areAllExpanded ? 'accordion_up' : 'accordion_down'"></mat-icon>
          </button>
        </th>
        <th>{{ 'general.api_delivery_types_table_classifier_name' | translate }}</th>
        <th>{{ 'general.api_delivery_types_table_name' | translate }}</th>
        <th width="25%">{{ 'general.api_delivery_types_table_description' | translate }}</th>
        <th>{{ 'general.api_delivery_types_table_sales_channels' | translate }}</th>
        <th class="align-right">{{ 'general.api_delivery_types_table_fee_amount' | translate }}</th>
        <th class="align-right">{{ 'general.api_delivery_types_table_fee_vat' | translate }}</th>
        <th>{{ 'general.api_delivery_types_table_fee_start' | translate }}</th>
        <th>{{ 'general.api_delivery_types_table_fee_end' | translate }}</th>
        <th class="align-right" *ngIf="activeTab === 0">
          {{ 'general.api_delivery_types_table_order' | translate }}
          <mat-icon class="svg-icon text-muted" [svgIcon]="'info'" [matTooltip]="'general.api_delivery_types_table_order_tooltip' | translate"></mat-icon>
        </th>
        <th class="min-width">&nbsp;</th>
      </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let deliveryType of sortedDeliveryTypes; let even = even; let first = first; let last = last">
          <tr *ngIf="!getRelevantPeriodPrices(deliveryType).length" [ngClass]="{'alternate' : even}">
            <td class="min-width">&nbsp;</td>
            <ng-container [ngTemplateOutlet]="deliveryTypeCommonDataCells" [ngTemplateOutletContext]="{deliveryType: deliveryType, evenRow: even}"></ng-container>
            <td class="align-right">-</td>
            <td class="align-right">-</td>
            <td>-</td>
            <td>-</td>
            <td>
              <button mat-button class="icon-button input-button small" (click)="editDeliveryType(deliveryType)">
                <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
              </button>
            </td>
          </tr>
          <ng-container *ngIf="activeTab === 1" [ngTemplateOutlet]="deliveryTypeRowsTemplate"
                        [ngTemplateOutletContext]="{deliveryType: deliveryType, evenRow: even}">
          </ng-container>
          <ng-container *ngIf="activeTab === 0" [ngTemplateOutlet]="deliveryTypeRowsTemplate"
                        [ngTemplateOutletContext]="{deliveryType: deliveryType, evenRow: even, firstDeliveryType: first, lastDeliveryType: last}"></ng-container>
        </ng-container>
      </tbody>
    </table>
    <ng-template #deliveryTypeRowsTemplate let-deliveryType="deliveryType" let-evenRow="evenRow" let-firstDeliveryType="firstDeliveryType" let-lastDeliveryType="lastDeliveryType">
      <tr *ngFor="let periodPrice of getRelevantPeriodPrices(deliveryType); let first = first" [ngClass]="{'alternate' : evenRow}">
        <td class="min-width" *ngIf="first" [rowSpan]="getRowSpan(deliveryType)">
          <button mat-button class="icon-button input-button small"
                  *ngIf="activeTab === 0 ? deliveryType.sortedFee?.currentAndFuturePeriodPrices?.length > 1 : deliveryType.sortedFee?.pastPeriodPrices?.length > 1"
                  (click)="$event.stopPropagation(); toggleDeliveryType(deliveryType.id)">
            <mat-icon class="svg-icon" [svgIcon]="expanded[deliveryType.id] ? 'arrow_up' : 'arrow_down'"></mat-icon>
          </button>
        </td>
        <ng-container *ngIf="first" [ngTemplateOutlet]="deliveryTypeCommonDataCells"
                      [ngTemplateOutletContext]="{deliveryType: deliveryType, evenRow: evenRow}"></ng-container>
        <td class="align-right white-space-no-wrap" *ngIf="expanded[deliveryType.fee.id] || first">
          {{ periodPrice.feeAmount | price }}
        </td>
        <td class="align-right white-space-no-wrap" *ngIf="expanded[deliveryType.fee.id] || first">
          {{ periodPrice.vatPercentage != null ? (periodPrice.vatPercentage + '%') : '' }}
        </td>
        <td *ngIf="expanded[deliveryType.sortedFee.id] || first">
          {{ periodPrice.period.start | moment: { format: viewService.conf.dateTimeFormat } }}
        </td>
        <td *ngIf="expanded[deliveryType.sortedFee.id] || first">
          {{ periodPrice.period.end ? (periodPrice.period.end | moment: { format: viewService.conf.dateTimeFormat }) : '...' }}
        </td>
        <td *ngIf="first && activeTab === 0" [rowSpan]="getRowSpan(deliveryType)" class="white-space-no-wrap align-right">
          <button mat-raised-button class="icon-button input-button small" (click)="!firstDeliveryType && updateOrder(deliveryType, -1)"
                  [disabled]="firstDeliveryType">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_up'"></mat-icon>
          </button>
          <button mat-button class="icon-button input-button small left-spacer-half" (click)="!lastDeliveryType && updateOrder(deliveryType, 1)"
                  [disabled]="lastDeliveryType">
            <mat-icon class="svg-icon" [svgIcon]="'arrow_down'"></mat-icon>
          </button>
        </td>
        <td class="min-width" *ngIf="first" [rowSpan]="getRowSpan(deliveryType)">
          <button mat-button class="icon-button input-button small" (click)="editDeliveryType(deliveryType)">
            <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
          </button>
        </td>
      </tr>
    </ng-template>
    <ng-template #deliveryTypeCommonDataCells let-deliveryType="deliveryType">
      <td [rowSpan]="getRowSpan(deliveryType)">
        <app-link [link]="deliveryType.classifierName" (linkClicked)="editDeliveryType(deliveryType)" [wrap]="true"></app-link>
      </td>
      <td [rowSpan]="getRowSpan(deliveryType)">
        {{ deliveryType.name | translateValue }}
      </td>
      <td [rowSpan]="getRowSpan(deliveryType)">
        {{ deliveryType.description | translateValue }}
      </td>
      <td [rowSpan]="getRowSpan(deliveryType)">
        {{ getDeliveryTypeChannels(deliveryType) }}
      </td>
    </ng-template>
    <!-- MOBILE -->
    <ng-container *ngIf="utilService.isMobile">
      <div class="listing-block" *ngFor="let deliveryType of sortedDeliveryTypes; let even = even; let index = index; let first = first; let last = last" [ngClass]="{'last-block': last}">
        <div class="header-block flex flex-grow space-between bottom-spacer">
          <div class="white-space-no-wrap flex flex-row-desktop flex-row-mobile">
            <app-link [link]="deliveryType.classifierName" [mobileHeading]="true" (linkClicked)="editDeliveryType(deliveryType)" [wrap]="true"></app-link>
          </div>
          <div class="flex flex-end decreased-margin">
            <ng-container *ngIf="activeTab === 0">
              <button mat-raised-button class="icon-button input-button" (click)="updateOrder(deliveryType, -1)" [disabled]="first">
                <mat-icon class="svg-icon" [svgIcon]="'arrow_up'"></mat-icon>
              </button>
              <button mat-button class="icon-button input-button" (click)="updateOrder(deliveryType, 1)" [disabled]="last">
                <mat-icon class="svg-icon" [svgIcon]="'arrow_down'"></mat-icon>
              </button>
            </ng-container>
            <button mat-button class="icon-button input-button left-spacer" (click)="editDeliveryType(deliveryType)">
              <mat-icon class="svg-icon" [svgIcon]="'pencil'"></mat-icon>
            </button>
          </div>
        </div>
        <table class="mobile-max-width bottom-spacer break-word">
          <tbody>
            <tr>
              <td>{{ 'general.api_delivery_types_table_name' | translate }}</td>
              <td class="align-right">{{ deliveryType.name | translateValue }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_delivery_types_table_description' | translate }}</td>
              <td class="align-right">{{ deliveryType.description | translateValue }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_delivery_types_table_sales_channels' | translate }}</td>
              <td class="align-right">{{ getDeliveryTypeChannels(deliveryType) }}</td>
            </tr>
            <ng-container *ngIf="!deliveryType.fee.periodPrices?.length">
              <tr class="with-separator">
                <td>{{ 'general.api_delivery_types_table_fee_amount' | translate }}</td>
                <td class="align-right">-</td>
              </tr>
              <tr>
                <td>{{ 'general.api_delivery_types_table_fee_vat' | translate }}</td>
                <td class="align-right">-</td>
              </tr>
              <tr>
                <td>{{ 'general.api_delivery_types_table_fee_start' | translate }}</td>
                <td class="align-right">-</td>
              </tr>
              <tr>
                <td>{{ 'general.api_delivery_types_table_fee_end' | translate }}</td>
                <td class="align-right">-</td>
              </tr>
            </ng-container>
            <ng-container *ngIf="activeTab === 1" [ngTemplateOutlet]="mobilePeriodPriceTemplate"
                          [ngTemplateOutletContext]="{deliveryType: deliveryType, periodPriceList: deliveryType.sortedFee.pastPeriodPrices}">
            </ng-container>
            <ng-container *ngIf="activeTab === 0" [ngTemplateOutlet]="mobilePeriodPriceTemplate"
                          [ngTemplateOutletContext]="{deliveryType: deliveryType, periodPriceList: deliveryType.sortedFee.currentAndFuturePeriodPrices}"></ng-container>
          </tbody>
        </table>
        <hr class="no-margin">
      </div>
      <ng-template #mobilePeriodPriceTemplate let-deliveryType="deliveryType" let-periodPriceList="periodPriceList">
        <ng-container *ngFor="let periodPrice of periodPriceList; let first = first">
          <ng-container *ngIf="first || expanded[deliveryType.id]">
            <tr class="with-separator">
              <td>{{ 'general.api_delivery_types_table_fee_amount' | translate }}</td>
              <td class="align-right">{{ periodPrice.feeAmount | price }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_delivery_types_table_fee_vat' | translate }}</td>
              <td class="align-right">{{ periodPrice.vatPercentage != null ? (periodPrice.vatPercentage + '%') : '' }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_delivery_types_table_fee_start' | translate }}</td>
              <td class="align-right">{{ periodPrice.period.start | moment: { format: viewService.conf.dateTimeFormat } }}</td>
            </tr>
            <tr>
              <td>{{ 'general.api_delivery_types_table_fee_end' | translate }}</td>
              <td class="align-right">{{ periodPrice.period.end ? (periodPrice.period.end | moment: { format: viewService.conf.dateTimeFormat }) : '...' }}</td>
            </tr>
          </ng-container>
        </ng-container>
        <tr *ngIf="periodPriceList?.length > 1">
          <td colspan="2" class="align-center">
            <app-link [link]="(expanded[deliveryType.id] ? 'general.api_show_less' : 'general.api_show_more')" (linkClicked)="toggleDeliveryType(deliveryType.id)"
                      [icon]="expanded[deliveryType.id] ? 'arrow_up' : 'arrow_down'" [linkClass]="'body-3 medium'"></app-link>
          </td>
        </tr>
      </ng-template>
    </ng-container>
  </mat-card>
</ng-container>
